/**
 * Bilingual text. SPEC §7.3.
 *
 * Malayalam and English on every applicant facing string and every generated
 * document. The Malayalam recovered from the published scans in docs/law is
 * machine translated and is never treated as authoritative; strings authored
 * here are marked so a Malayalam reader can check them.
 */

export type Lang = "en" | "ml";

export const LANGS: readonly Lang[] = ["en", "ml"] as const;

export interface Bilingual {
  en: string;
  ml: string;
}

export const bi = (en: string, ml: string): Bilingual => ({ en, ml });

export const pick = (t: Bilingual, lang: Lang): string => t[lang] || t.en;

/** Both languages, one after the other. Used on generated documents. */
export const both = (t: Bilingual, separator = "\n"): string =>
  `${t.en}${separator}${t.ml}`;

export const isComplete = (t: Bilingual): boolean =>
  t.en.trim().length > 0 && t.ml.trim().length > 0;
